/**
 * Saves `blob` to disk as `filename` through a temporary `<a download>` (MAR-948 wave 1).
 *
 * The anchor is attached to the document before it is clicked: Firefox and Safari silently no-op a
 * click on a detached anchor. The object URL is revoked right after the click, by which point the
 * browser has already taken the download.
 *
 * Only for bytes already in hand. A cross-origin URL cannot be saved this way — the browser ignores
 * `download` there — which is why `downloadItemFile` and `useArtifactDownload` fetch the bytes first
 * and fall back to a plain navigation when that read fails.
 *
 * Guarded by `tests/unit/saveBlobGuard.test.ts`: `URL.createObjectURL` anywhere else in `app/` fails
 * the suite.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
